import { Logger } from '@samelogic/steps';
import { WorkflowConfig } from '../../models';
import { PackageMemoryCache } from '../Steps/Repository/PackageMemoryCache';
import { TriggerManager } from '../Triggers';
import { StepContainerManager } from '../Steps';
import { Context } from '../Context/Context';
import { EventLogger } from '../../tracking/EventLogger';

export class WorkflowManager {
  private triggerManager: TriggerManager;
  private containerManager: StepContainerManager;
  constructor(
    private readonly context: Context,
    private readonly workflow: WorkflowConfig,
    private readonly packageMemoryCache: PackageMemoryCache,
    private readonly logger: Logger,
    public readonly eventLogger: EventLogger
  ) {
    this.triggerManager = new TriggerManager(this.context, this.logger, this.workflow.triggers);
    this.triggerManager.onTriggered = async () => await this.onTriggerExecuted();

    this.eventLogger.setWorkflowConfig(workflow);

    this.containerManager = new StepContainerManager(
      this.workflow.steps,
      this.packageMemoryCache,
      this.logger,
      this.eventLogger
    );
  }

  public start(): void {
    this.triggerManager.start();
  }

  private onTriggerExecuted = async (): Promise<void> => {
    await this.containerManager.start(this.context);
  };
}
